"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactIntl = require("react-intl");
var _state = require("@myci/state");
var _utils = require("@creditinfo-ui/utils");
var _jsxRuntime = require("react/jsx-runtime");
// eslint-disable-next-line react/display-name,react/prop-types
var _default = exports.default = function _default(_ref, pluginOptions) {
  var element = _ref.element;
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  var applicationType = pluginOptions.applicationType;
  var _createReactHookThunk = (0, _utils.createReactHookThunkDependency)(_reactIntl.useIntl),
    IntlProducer = _createReactHookThunk[0],
    getIntl = _createReactHookThunk[1];
  var store = (0, _state.configureStore)({
    applicationType: applicationType,
    getIntl: getIntl
  });
  store.IntlProducer = IntlProducer;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRedux.Provider, {
    store: store,
    children: element
  });
};